import moment from "moment";

export const displayDateFilter = (date: string | null | undefined) =>
  date ? moment(date).format("DD.MM.YYYY") : "...";
